import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { AudioManager } from "./AudioManager";

export class GameManager {

    public static init(): void {

        window["GD_OPTIONS"] = {
            "gameId": "5e93b828d7164ec381ce02f4c2fae19a",
            "onEvent": function(event: any): any {
                switch (event.name) {
                    case "SDK_GAME_START":
                        if (!GameVars.gameData.muted) {
                            AudioManager.unmute();
                        }

                        if (!GameVars.gameOver) {
                            GameVars.currentScene.scene.start("BoardScene");
                        }
                        
                        break;
                    case "SDK_GAME_PAUSE":
                        if (!GameVars.gameData.muted) {
                            AudioManager.mute();
                        }
                        break;
                    case "SDK_GDPR_TRACKING":
                        console.log("SDK_GDPR_TRACKING");
                        break;
                    case "SDK_GDPR_TARGETING":
                        console.log("SDK_GDPR_TARGETING");
                        break;
                    default:
                        break;
                }
            },
        };
        (function(d: any, s: any, id: any): any {
            var js: any, fjs: any = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "gamedistribution-jssdk"));

        GameVars.isDesktop = GameVars.currentScene.sys.game.device.os.desktop && !(navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));

        if (GameVars.isDesktop) {

            GameVars.scaleY = 1;

        } else {

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            const aspectRatio = window.innerHeight / window.innerWidth;
            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / aspectRatio;
        }

        GameManager.readGameData();
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        language: "en",
                        tutorialLabelsSeen: false,
                        logs: []
                    };
                }

                GameVars.resumedGame = GameVars.gameData.logs.length > 0;

                GameManager.startGame();
            }
        );
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {

        AudioManager.init();

        GameVars.gameText = GameVars.currentScene.cache.json.get("game-text");

        if (GameVars.resumedGame) {
            GameManager.enterBoardScene();
        } else {
            GameManager.enterSplashScene();
        } 
    }

    public static startResumedGameCallback(): void {
        
        GameManager.enterBoardScene();
    }

    public static enterSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static enterDuelSplashScene(): void {

        GameVars.currentScene.scene.start("DuelSplashScene");
    }

    public static enterTournamentSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static enterBoardScene(): void {

        if (GameVars.resumedGame) {
            GameVars.currentScene.scene.start("BoardScene");
        } else {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
            } else {
                GameVars.currentScene.scene.start("BoardScene");
            }
        }
    }

    public static resetGame(): void {

        GameManager.enterBoardScene();
    }

    public static onTutorialLabelsSeen(): void {

        GameVars.gameData.tutorialLabelsSeen = true;

        GameManager.writeGameData();
    }

    public static logBoard(): void {

        const board = GameVars.templokEngine.board;

        console.log(JSON.stringify(board));
        console.log("first seed:", GameVars.seed);
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
